import { useParams } from 'react-router-dom';

export interface BaseDashboardContextProps {
  project_id?: number | null;
  site_id?: number | null;
  grid_id?: number | null;
}

export interface NoContextProps {
  mode: 'nocontext';
}

export interface FullContextProps extends Required<BaseDashboardContextProps> {
  mode: 'fullcontext';
}

export interface DashbordOnlyContextProps
  extends BaseDashboardContextProps {
  mode: 'dashbordonly';
}

export type DashboardContextProps =
  | NoContextProps
  | FullContextProps
  | DashbordOnlyContextProps;

type Result = Required<BaseDashboardContextProps>;

type Precedence = 'params' | 'props';

export function useDashboardContext(
  props: DashboardContextProps,
  precedence: Precedence = 'params'
): Result {
  const params = useParams<{
    project_id?: string;
    site_id?: string;
    grid_id?: string;
  }>();

  const projectFromParams = params.project_id
    ? Number(params.project_id)
    : null;
  const siteFromParams = params.site_id ? Number(params.site_id) : null;
  const gridFromParams = params.grid_id ? Number(params.grid_id) : null;

  let project_id: number | null = null;
  let site_id: number | null = null;
  let grid_id: number | null = null;

  switch (props.mode) {
    case 'nocontext': {
      project_id = projectFromParams ?? null;
      site_id = siteFromParams ?? null;
      grid_id = gridFromParams ?? null;
      break;
    }

    case 'fullcontext': {
      project_id =
        precedence === 'params'
          ? projectFromParams ?? props.project_id
          : props.project_id ?? projectFromParams;

      site_id =
        precedence === 'params'
          ? siteFromParams ?? props.site_id
          : props.site_id ?? siteFromParams;

      grid_id =
        precedence === 'params'
          ? gridFromParams ?? props.grid_id
          : props.grid_id ?? gridFromParams;
      break;
    }

    case 'dashbordonly': {
      grid_id =
        precedence === 'params'
          ? gridFromParams ?? props.grid_id ?? null
          : props.grid_id ?? gridFromParams ?? null;

      project_id = projectFromParams ?? null;
      site_id = siteFromParams ?? null;
      break;
    }
  }

  return { project_id, site_id, grid_id };
}
